/** Parse an integer value & never return NaN. */
export function safeParseInt(
  value: number | string | null | undefined
): number | null {
  if (
    typeof value !== 'number'
    && typeof value !== 'string'
  ) {
    return null;
  }

  const parsedValue = parseInt(value as string, 10);
  return (isNaN(parsedValue)) ? null : parsedValue;
}
